import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiCheck, FiStar } from 'react-icons/fi';

const Comparison = () => {
  const columns = [
    {
      title: 'AIMM Briefing Membership',
      price: '$28.31/mo',
      items: [
        '2-4 episodes of the full AIMM + AIRena half hour',
        'Speaker takeaways',
        'Strategic meeting breakdown',
        'Core Smart Connect access',
        'Quarterly check-in',
        'RepUpgrade Reputation Report'
      ]
    },
    {
      title: 'Build Your Network Membership',
      price: '$129.46/mo',
      isFeatured: true,
      items: [
        'Everything in AIMM Briefing Membership',
        'AI Industry Strategy Rooms',
        'WhatsApp Community',
        'Custom Territory channels',
        'AI Business Consultant Directory listing',
        'Quarterly guidance',
        'RepUpgrade Reputation Report'
      ]
    }
  ];

  return (
    <section className="py-16 px-6 max-w-5xl mx-auto">
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="text-2xl md:text-3xl font-bold text-dc-teal-deep text-center mb-12"
      >
        Compare Memberships
      </motion.h2>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="bg-white rounded-3xl shadow-soft border border-dc-teal-deep/5 overflow-hidden"
      >
        <div className="grid md:grid-cols-2 divide-y md:divide-y-0 md:divide-x divide-dc-teal-deep/10">
          {columns.map((column, idx) => (
            <div key={idx} className={`p-8 md:p-10 ${column.isFeatured ? 'bg-gradient-to-b from-dc-gold-1/5 to-transparent' : ''}`}>
              <div className="flex items-center gap-2 mb-2">
                <h3 className="font-bold text-dc-teal-deep text-xl pb-4 border-b-2 border-dc-teal-deep/10 flex-grow">
                  {column.title}
                </h3>
                {column.isFeatured && (
                  <SafeIcon icon={FiStar} className="w-5 h-5 text-dc-gold-1 flex-shrink-0" />
                )}
              </div>
              <div className="text-dc-teal-deep font-semibold mb-6">{column.price}</div>
              <ul className="space-y-4">
                {column.items.map((item, itemIdx) => (
                  <li key={itemIdx} className="text-dc-text/80 text-base flex items-start">
                    <div className="w-6 h-6 rounded-full bg-dc-teal-signal/10 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                      <SafeIcon icon={FiCheck} className="w-3.5 h-3.5 text-dc-teal-signal" />
                    </div>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Comparison;